const ITEM_GRID_XLRG = 1450;
const ITEM_GRID_LRG = 1300;
const ITEM_GRID_MED = 1150;
const ITEM_GRID_SML = 870;
const ITEM_GRID_XSML = 720;

const SLIDER_BREAKPOINTS = [
    {
        breakpoint: ITEM_GRID_XLRG,
        slides: 7,
        slidesToScroll: 7
    },
    {
        breakpoint: ITEM_GRID_LRG,
        slides: 6,
        slidesToScroll: 6
    },
    {
        breakpoint: ITEM_GRID_MED,
        slides: 5,
        slidesToScroll: 5
    },
    {
        breakpoint: ITEM_GRID_SML,
        slides: 4,
        slidesToScroll: 4
    },
    {
        breakpoint: ITEM_GRID_XSML,
        slides: 3,
        slidesToScroll: 3
    }
];

export const MAX_TILE_WIDTH = 210;

export const MAX_SLIDES_TO_SHOW = 7;

export const customSettings = {
    slidesToShow: MAX_SLIDES_TO_SHOW,
    isInfinite: false,
    slidesToScroll: MAX_SLIDES_TO_SHOW,
    sliderBreakpoints: SLIDER_BREAKPOINTS
};

export const MINIMUN_TILES_LENGTH = 2;
